export const environment = {
  production: false,
  enableEditorSandbox: true, // development sandbox route, must be false on production
  graphqlUrl: "https://design.berufsreise-dev.at/graphql/",
  graphqlUrlInternal: "https://design.berufsreise-dev.at/graphql/internal",
  googleMapsApiKey: "AIzaSyDgg679njw1wY16EalEIGYwQ17kvSsLyog", // localhost
  mqttBroker: "wss://broker.berufsreise-dev.at/mosquitto",
  mqttTopic: "brt-timestamp",
  oAuthRedirectUri: "https://dev.berufsreise-dev.at/oauthlogin",
  oAuthProviderEndpoint: "https://design.berufsreise-dev.at",
  schoolClassPreviewMode: false,
  jobsCacheUrl: "https://www.berufsreise.at/jobs-cache"
};
